import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ua-head" }
const _hoisted_2 = { class: "uh-actions" }
const _hoisted_3 = { class: "row-actions" }
const _hoisted_4 = { class: "del-body" }
const _hoisted_5 = { class: "ff-actions" }
const _hoisted_6 = { class: "firma-form" }
const _hoisted_7 = { class: "ff-row" }
const _hoisted_8 = { class: "ff-field ff-full" }
const _hoisted_9 = { class: "ff-row" }
const _hoisted_10 = { class: "ff-field ff-full" }
const _hoisted_11 = { class: "ff-row" }
const _hoisted_12 = { class: "ff-field ff-full" }
const _hoisted_13 = { class: "ff-actions" }
const _hoisted_14 = { class: "firma-form" }
const _hoisted_15 = { class: "ff-row" }
const _hoisted_16 = { class: "ff-row" }
const _hoisted_17 = {
  key: 0,
  class: "import-result"
}
const _hoisted_18 = {
  key: 0,
  class: "import-errors"
}
const _hoisted_19 = { class: "ff-actions" }
const _hoisted_20 = { class: "companies-body" }
const _hoisted_21 = {
  key: 0,
  class: "companies-empty"
}
const _hoisted_22 = {
  key: 1,
  class: "companies-empty"
}
const _hoisted_23 = {
  key: 2,
  class: "companies-grid"
}
const _hoisted_24 = { class: "comp-avatar" }
const _hoisted_25 = { class: "comp-name" }
const _hoisted_26 = {
  key: 0,
  class: "comp-inactive"
}
const _hoisted_27 = { class: "companies-add-row" }
const _hoisted_28 = { class: "ff-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxPager = _resolveComponent("DxPager")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DxPopup = _resolveComponent("DxPopup")!
  const _component_DxTextBox = _resolveComponent("DxTextBox")!
  const _component_DxFileUploader = _resolveComponent("DxFileUploader")!
  const _component_DxSelectBox = _resolveComponent("DxSelectBox")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    flat: "",
    class: "pa-4"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[13] || (_cache[13] = _createElementVNode("span", { class: "uh-title" }, "Utilizatori aplicație", -1)),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_DxButton, {
            text: "Import Excel",
            icon: "upload",
            "styling-mode": "outlined",
            onClick: _ctx.openImport
          }, null, 8, ["onClick"]),
          _createVNode(_component_DxButton, {
            text: "Creează utilizator",
            icon: "add",
            type: "default",
            "styling-mode": "contained",
            onClick: _ctx.openCreate
          }, null, 8, ["onClick"])
        ])
      ]),
      _createVNode(_component_v_divider, { class: "my-3" }),
      _createVNode(_component_DxDataGrid, {
        "data-source": _ctx.users,
        "key-expr": "ID",
        "show-borders": true,
        "show-column-lines": false,
        "show-row-lines": true,
        "row-alternation-enabled": true,
        "hover-state-enabled": true,
        "column-auto-width": true,
        "allow-column-resizing": true
      }, {
        activeCell: _withCtx(({ data }) => [
          _createElementVNode("span", {
            class: _normalizeClass(["ua-badge", data.data.Active ? 'on' : 'off'])
          }, _toDisplayString(data.data.Active ? 'Activ' : 'Inactiv'), 3)
        ]),
        boolCell: _withCtx(({ data }) => [
          (data.value)
            ? (_openBlock(), _createBlock(_component_v_icon, {
                key: 0,
                color: "#059669",
                size: "18"
              }, {
                default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                  _createTextVNode("mdi-check-circle", -1)
                ]))]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_v_icon, {
                key: 1,
                color: "#cbd5e1",
                size: "18"
              }, {
                default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                  _createTextVNode("mdi-minus-circle-outline", -1)
                ]))]),
                _: 1
              }))
        ]),
        actions: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_DxButton, {
              text: data.data.Active ? 'Dezactivează' : 'Activează',
              "styling-mode": "text",
              onClick: ($event: any) => (_ctx.toggleActive(data.data))
            }, null, 8, ["text", "onClick"]),
            _createVNode(_component_DxButton, {
              icon: "key",
              hint: "Resetează parola",
              "styling-mode": "text",
              onClick: ($event: any) => (_ctx.openReset(data.data))
            }, null, 8, ["onClick"]),
            _createVNode(_component_DxButton, {
              icon: "event",
              hint: "Companii",
              "styling-mode": "text",
              onClick: ($event: any) => (_ctx.openCompanies(data.data))
            }, null, 8, ["onClick"])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_DxSearchPanel, {
            visible: true,
            placeholder: "Caută utilizator..."
          }),
          _createVNode(_component_DxPaging, { "page-size": 10 }),
          _createVNode(_component_DxPager, {
            "show-page-size-selector": true,
            "allowed-page-sizes": [10, 20, 50],
            "show-info": ""
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Username",
            caption: "Utilizator"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Email",
            caption: "Email"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Active",
            caption: "Activ",
            width: 120,
            alignment: "center",
            "cell-template": "activeCell"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "SuperAdmin",
            caption: "SuperAdmin",
            width: 120,
            alignment: "center",
            "cell-template": "boolCell"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "ADAccount",
            caption: "Cont AD",
            width: 110,
            alignment: "center",
            "cell-template": "boolCell"
          }),
          _createVNode(_component_DxColumn, {
            caption: "",
            width: 230,
            "cell-template": "actions"
          })
        ]),
        _: 1
      }, 8, ["data-source"]),
      _createVNode(_component_DxPopup, {
        visible: _ctx.resetVisible,
        "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.resetVisible) = $event)),
        title: "Resetare parolă",
        width: 420,
        height: "auto",
        "drag-enabled": false,
        "wrapper-attr": { class: 'era-edit-popup' }
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", null, [
              _cache[16] || (_cache[16] = _createTextVNode("Sigur vrei să resetezi parola pentru ", -1)),
              _createElementVNode("strong", null, "„" + _toDisplayString(_ctx.toReset && _ctx.toReset.Username) + "\"", 1),
              _cache[17] || (_cache[17] = _createTextVNode("?", -1))
            ]),
            _cache[19] || (_cache[19] = _createElementVNode("p", { class: "del-warn" }, "Se va genera o parolă nouă și se va trimite pe email.", -1)),
            _createElementVNode("div", _hoisted_5, [
              _cache[18] || (_cache[18] = _createElementVNode("span", { class: "ff-spacer" }, null, -1)),
              _createVNode(_component_DxButton, {
                text: "Resetează",
                type: "default",
                "styling-mode": "contained",
                onClick: _ctx.confirmReset
              }, null, 8, ["onClick"]),
              _createVNode(_component_DxButton, {
                text: "Anulează",
                "styling-mode": "outlined",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.resetVisible = false))
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_DxPopup, {
        visible: _ctx.createVisible,
        "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.createVisible) = $event)),
        title: "Creează utilizator",
        width: 480,
        height: "auto",
        "drag-enabled": false,
        "wrapper-attr": { class: 'era-edit-popup' }
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _cache[20] || (_cache[20] = _createElementVNode("label", null, "Utilizator", -1)),
                _createVNode(_component_DxTextBox, {
                  value: _ctx.createForm.Username,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.createForm.Username) = $event)),
                  placeholder: "ion.popescu"
                }, null, 8, ["value"])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _cache[21] || (_cache[21] = _createElementVNode("label", null, "Email", -1)),
                _createVNode(_component_DxTextBox, {
                  value: _ctx.createForm.Email,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.createForm.Email) = $event)),
                  placeholder: "ion.popescu@exemplu.ro"
                }, null, 8, ["value"])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _cache[22] || (_cache[22] = _createElementVNode("label", null, "Parolă (opțional — se generează automat dacă lipsește)", -1)),
                _createVNode(_component_DxTextBox, {
                  value: _ctx.createForm.Password,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.createForm.Password) = $event)),
                  mode: "password",
                  placeholder: "•••••••••"
                }, null, 8, ["value"])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[23] || (_cache[23] = _createElementVNode("span", { class: "ff-spacer" }, null, -1)),
              _createVNode(_component_DxButton, {
                text: "Creează",
                type: "default",
                "styling-mode": "contained",
                onClick: _ctx.submitCreate
              }, null, 8, ["onClick"]),
              _createVNode(_component_DxButton, {
                text: "Anulează",
                "styling-mode": "outlined",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.createVisible = false))
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_DxPopup, {
        visible: _ctx.importVisible,
        "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.importVisible) = $event)),
        title: "Import utilizatori din Excel",
        width: 520,
        height: "auto",
        "drag-enabled": false,
        "wrapper-attr": { class: 'era-edit-popup' }
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_14, [
            _cache[29] || (_cache[29] = _createElementVNode("p", { class: "import-hint" }, [
              _createTextVNode(" Coloane: "),
              _createElementVNode("strong", null, "Username, Email, Parola, Firme"),
              _createTextVNode(" (firmele se separă prin virgulă). Parola poate fi lăsată goală — se generează automat. ")
            ], -1)),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("a", {
                href: "#",
                class: "import-template-link",
                onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.downloadTemplate && _ctx.downloadTemplate(...args)), ["prevent"]))
              }, [...(_cache[24] || (_cache[24] = [
                _createElementVNode("i", { class: "dx-icon dx-icon-download" }, null, -1),
                _createTextVNode(" Descarcă template ", -1)
              ]))])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_DxFileUploader, {
                multiple: false,
                accept: ".csv,.xlsx,.xls",
                "upload-mode": "useForm",
                "select-button-text": "Alege fișier",
                "label-text": "sau trage fișierul aici",
                onValueChanged: _ctx.onImportFileChanged
              }, null, 8, ["onValueChanged"])
            ]),
            (_ctx.importResult)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("p", null, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.importResult.Creati), 1),
                    _cache[25] || (_cache[25] = _createTextVNode(" conturi create, ", -1)),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.importResult.AdaugatiLaFirme), 1),
                    _cache[26] || (_cache[26] = _createTextVNode(" alocări la firme.", -1))
                  ]),
                  (_ctx.importResult.Erori && _ctx.importResult.Erori.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _cache[27] || (_cache[27] = _createElementVNode("p", { class: "import-errors-title" }, "Erori:", -1)),
                        _createElementVNode("ul", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.importResult.Erori, (e, i) => {
                            return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(e), 1))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_19, [
              _cache[28] || (_cache[28] = _createElementVNode("span", { class: "ff-spacer" }, null, -1)),
              _createVNode(_component_DxButton, {
                text: "Importă",
                type: "default",
                "styling-mode": "contained",
                disabled: !_ctx.importFile,
                onClick: _ctx.submitImport
              }, null, 8, ["disabled", "onClick"]),
              _createVNode(_component_DxButton, {
                text: "Închide",
                "styling-mode": "outlined",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.importVisible = false))
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_DxPopup, {
        visible: _ctx.companiesVisible,
        "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.companiesVisible) = $event)),
        title: `Companii — ${_ctx.companiesUsername}`,
        width: 520,
        height: "auto",
        "drag-enabled": false,
        "show-close-button": true,
        "close-on-outside-click": true,
        "wrapper-attr": { class: 'era-edit-popup' }
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_20, [
            (_ctx.companiesLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, "Se încarcă..."))
              : (_ctx.companiesList.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, "Nicio companie asociată."))
                : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companiesList, (c) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: c.ID,
                        class: "comp-row"
                      }, [
                        _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.ini(c.Name)), 1),
                        _createElementVNode("span", _hoisted_25, _toDisplayString(c.Name), 1),
                        (c.Active === false)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_26, "inactivă"))
                          : _createCommentVNode("", true),
                        _createVNode(_component_DxButton, {
                          icon: "trash",
                          "styling-mode": "text",
                          type: "danger",
                          hint: "Scoate din firmă",
                          onClick: ($event: any) => (_ctx.removeCompany(c))
                        }, null, 8, ["onClick"])
                      ]))
                    }), 128))
                  ])),
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_component_DxSelectBox, {
                value: _ctx.companyToAdd,
                "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.companyToAdd) = $event)),
                "data-source": _ctx.companiesNotAdded,
                "display-expr": "Name",
                "value-expr": "ID",
                placeholder: "Alege o firmă...",
                style: {"flex":"1"}
              }, null, 8, ["value", "data-source"]),
              _createVNode(_component_DxButton, {
                text: "Adaugă",
                type: "default",
                "styling-mode": "contained",
                disabled: !_ctx.companyToAdd,
                onClick: _ctx.addCompany
              }, null, 8, ["disabled", "onClick"])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _cache[30] || (_cache[30] = _createElementVNode("span", { class: "ff-spacer" }, null, -1)),
              _createVNode(_component_DxButton, {
                text: "Închide",
                "styling-mode": "outlined",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.companiesVisible = false))
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible", "title"])
    ]),
    _: 1
  }))
}